import { render } from "./SwiperComponent.vue?vue&type=template&id=b3637142&scoped=true"
import script from "./SwiperComponent.vue?vue&type=script&lang=js"
export * from "./SwiperComponent.vue?vue&type=script&lang=js"

import "./SwiperComponent.vue?vue&type=style&index=0&id=b3637142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3637142"]])

export default __exports__